<template>
  <section>
    <Clock city='America/Los_Angeles' />
    <Clock city='America/New_York' />
    <Clock city='Europe/Paris' />
    <Clock city='Europe/Helsinki' />
  </section>
</template>

<style scoped>
section {
  width: fit-content;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;
  place-items: center;
}

section > * {
  margin: 4rem;
}

@media (max-width: 60rem) {
  section {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
